import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppState } from '../../models/state';
import { ContextService } from '../../services/ctx.service';
import { NavService } from '../../services/nav.service';
import { StateService } from '../../services/state.service';
import { UiService } from '../../services/ui.service';


@Component({
  selector: 'app-header-search',
  templateUrl: './header-search.component.html',
  styleUrls: ['./header-search.component.scss']
})
export class HeaderSearchComponent implements OnInit {

  @Input() address: string;
  @Input() itemName: string;
  @Input() isMapOpen: boolean;
  @Input() totalResults: number;
  @Output() viewMap: EventEmitter<boolean>;

  state: Partial<AppState>;
  subs: Subscription;

  constructor(
    public dialog: MatDialog,
    public ui: UiService,
    public ctx: ContextService,
    private nav: NavService,
    private stateService: StateService,
  ) {
    this.address = '';
    this.isMapOpen = false;
    this.itemName = '';
    this.viewMap = new EventEmitter();
    this.state = this.stateService.getStateValue();
    this.subs = new Subscription();
  }

  ngOnInit(): void {
    this.subs.add(
      this.stateService.getState().subscribe(state => { this.state = state; })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  onViewMap() {
    this.viewMap.emit(true);
  }

  onChangeSearch() {
    const breadcrumbs = this.state.getBreadcrumbs();
    breadcrumbs[2]?.navTo();
  }

  getTotalResultLabel(): string {
    return this.totalResults === 1
      ? `${this.totalResults} ${this.state.hideSpecialistsTab ? 'centro' : 'centro o especialista'} a tu disposición`
      : `${this.totalResults} ${this.state.hideSpecialistsTab ? 'centros' : 'centros o especialistas'} a tu disposición`;
  }

}
